import { trackUIInteraction } from '../../../../utils/analyticsEvents';
import { categorizeItems } from '../../../../store/actions/item/categorizeItems';
import { nodeMenuCopy } from '../../../../store/actions/nodeMenu/copy';
import { nodeMenuCut } from '../../../../store/actions/nodeMenu/cut';
import { moveCategory } from '../../../../store/actions/nodeMenu/moveCategory';
import { pasteCopy } from '../../../../store/actions/nodeMenu/pasteCopy';
import { pasteMove } from '../../../../store/actions/nodeMenu/pasteMove';
import { isCategorize, isPastable } from '../../../../utils/command';
import { hasSameContent } from '../../../../utils/tree/treeNode';
import {
  NODE_TYPE_CATEGORY,
  NODE_TYPE_ITEM,
} from '../../../../utils/types/nodeTypes';

export function getCategoryActions(
  {
    allowCutCategory,
    allowRanking,
    allowRankingLevels,
    canPaste,
    canCopyNode,
    canCopyToCatalogType,
  },
  { directive, dispatch, isCopy, nodeItem, nodeItems, otherPane, sourceTree, tree },
) {
  const nodeActions = {};

  const showCopyAction =
    canCopyToCatalogType(otherPane?.catalogType) && canCopyNode(nodeItem.node);
  if (showCopyAction) {
    nodeActions.nodeMenuCopy = () => {
      trackUIInteraction('copy_category', { id: nodeItem.node.id });
      dispatch(nodeMenuCopy(tree, nodeItem));
    };
  }
  if (allowCutCategory) {
    nodeActions.nodeMenuCut = () => {
      trackUIInteraction('cut_category', { id: nodeItem.node.id });
      dispatch(nodeMenuCut(tree, nodeItem));
    };
  }

  let isRankingAllowed =
    allowRankingLevels.length > 0
      ? allowRankingLevels.includes(nodeItem.node.level)
      : allowRanking;

  if (isRankingAllowed) {
    nodeActions.nodeMenuMoveUp = (callback) => {
      trackUIInteraction('move_category', { id: nodeItem.node.id, direction: 'up' });
      dispatch(
        moveCategory({
          tree,
          nodeItem,
          callback,
          direction: '-',
        }),
      );
    };
    nodeActions.nodeMenuMoveDown = (callback) => {
      trackUIInteraction('move_category', {
        id: nodeItem.node.id,
        direction: 'down',
      });
      dispatch(moveCategory({ tree, nodeItem, callback, direction: '+' }));
    };
  }

  const pastableContent = canPaste({
    nextParent: nodeItem.node,
    node: nodeItems?.[0]?.node,
  });

  const sourceType = nodeItems?.[0]?.node?.type;
  if (pastableContent) {
    const childCategoryCount = nodeItem.node?.category?.childCategoryCount;
    const childItemCount = nodeItem.node?.category?.childItemCount;
    if (isCategorize(directive) && !childCategoryCount) {
      nodeActions.pasteAction = async (callback) => {
        trackUIInteraction(
          sourceType === NODE_TYPE_ITEM ? 'paste_item' : 'paste_category',
          {
            id: nodeItem.node.id,
            type: sourceType,
          },
        );
        await dispatch(categorizeItems(tree, nodeItem));
        callback();
      };
    }
    if (isPastable(directive)) {
      const isCommandItem =
        sourceTree === tree && hasSameContent(nodeItem, nodeItems);
      if (
        !isCommandItem &&
        ((sourceType === NODE_TYPE_ITEM && !childCategoryCount) ||
          (sourceType === NODE_TYPE_CATEGORY && !childItemCount))
      ) {
        nodeActions.pasteAction = isCopy
          ? async (callback) => {
              trackUIInteraction(
                sourceType === NODE_TYPE_ITEM ? 'paste_item' : 'paste_category',
                {
                  id: nodeItem.node.id,
                  type: sourceType,
                },
              );
              await dispatch(pasteCopy(tree, nodeItem));
              callback();
            }
          : async (callback) => {
              trackUIInteraction(
                sourceType === NODE_TYPE_ITEM ? 'paste_item' : 'paste_category',
                {
                  id: nodeItem.node.id,
                  type: sourceType,
                },
              );
              await dispatch(pasteMove(tree, nodeItem));
              callback();
            };
      }
    }
  }

  return nodeActions;
}
